import React from 'react'

const bavaria = {
    id:  'bavaria',
    type: 'post',
    countryId: 'westernEurope',
    title: 'How to Have an Awesome Long Weekend in Bavaria',
    longDate: 'August 9, 2019',
    month: 'Aug',
    date: '9',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/westernEurope/bavaria/cover.jpg',
    content: [
        {
            text: (
                <div>Nine years ago, I studied abroad in Russia with a small group of Stanford students. My friend Grace was in that group, and we both lived in Slav (the Russian-themed house at Stanford) our senior year for even more Russian-ness. But she moved to D.C. after college and we only had the chance to see each other once since then. She's been in the Navy for a few years and just got an assignment in Stuttgart, so of course I wanted to meet up in Germany – and Munich was easy for both of us to get to. Seeing that the Alps were a short drive away, of course we planned to see some mountains as well!</div>
            )
        },
        {
            text: (
                <div>From sausages to steins to ridiculously decked-out castles, Bavaria was pretty fun. Here's how we made the most of our short trip! (First note: in the future, I'm going to avoid late July. It was over 90 degrees in Munich and nowhere has AC, even the offices at Volkswagen and Audi!!)</div>
            )
        },
        {
            header: 'Step One: Ride in style'
        },
        {
            text: (
                <div>Rent a car, and get a free upgrade. (I have no idea how they actually dole these out, by the way.) We reserved Sixt's cheapest and smallest car, and they gave us a two-door Audi. I think that's considered a "basic" car in Germany. Pretty awesome for zooming down the highways – which have no speed limits – and watching the Alps get closer and closer.</div>
            )
        },
        {
            text: (
                <div>Also, I recommend getting lost while zooming around in your Audi. We accidentally stumbled across the abandoned medieval Ehrenberg Castle, perched on a rock above the highway (plus a huge suspension bridge leading to it) and it was one of the happiest discoveries we've made our entire year abroad.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/westernEurope/bavaria/car.jpg' 
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/westernEurope/bavaria/ehrenberg1.jpg' 
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/westernEurope/bavaria/ehrenberg2.jpg' 
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/westernEurope/bavaria/bridge1.jpg','https://plivesey.github.io/world-of-wander-images/posts/westernEurope/bavaria/bridge2.jpg']
        },
        {
            header: 'Step Two: Beer gardens!'
        },
        {
            text: (
                <div>Any list of 'what to do in Munich' will list places to get stupidly large glasses of beer for cheap, preferably with a pretzel and/or sausage. On our first day in Munich we took a leisurely bike tour through Airbnb and ended at Viktualien Markt for a lunch beer. From there, we hit a beer garden nearly every early afternoon and evening. Our favorite: <a href="https://www.google.com/maps/place/Andy's+Krablergarten/@48.1334547,11.5680626,15.25z/data=!4m13!1m7!3m6!1s0x479e75f9a38c5fd9:0x10cb84a7db1987d!2sMunich,+Germany!3b1!8m2!3d48.1351253!4d11.5819806!3m4!1s0x479ddf5ed298e06b:0x3513b09018597a80!8m2!3d48.1324258!4d11.5666911">Andy's Krablergarten</a>, where the Schnitzel are large enough for two people or a lunch tomorrow, but you should definitely attempt to eat the whole thing. Thursdays are "Schnitzel Day", by the way, but you can and should get them every day.</div>
            )
        },
        {
            text: (
                <div>Another touristy but good one: the beer garden at the Chinese pagoda in the English garden. Those names make it sound foreign, but the park is very German (complete with nude sunbathers) and a cold beer is the perfect way to finish off an afternoon of sunbathing next to the river.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/westernEurope/bavaria/englishgarden.jpg' 
        },
        {
            header: 'Step Three: Shell out for the gondolas'
        },
        {
            text: (
                <div>Luckily, the heat wave ended when we drove south to Hohenschwangau to see Neuschwanstein, and on our second day in the area, we did a hike to the Alpsee followed by a misty and cloudy ride up the Tegelbergbahn. The attendant warned us there would be no view in that weather, but ascending up into clouds so thick you couldn't even see the trees beneath you was still very cool. Of course, we got a beer at the top before heading back down.</div>
            )
        },
        {
            text: (
                <div>In Garmisch-Partenkirchen, I shelled out an incredible 65 Euros to take the gondola to the top of Zugspitz, the highest point in Germany. If Peter had also wanted to go (after the Schwangau ride into mist, he was happy to keep his feet on the ground), we might have called it off at that price point, but I'm  glad I went up. Zugspitz is so high it's actually <i>above</i> the clouds, so I was standing in a little island of sunshine surrounded by snowy, misty peaks. Amazing.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/westernEurope/bavaria/zugspitz1.jpg' 
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/westernEurope/bavaria/zugspitz2.jpg','https://plivesey.github.io/world-of-wander-images/posts/westernEurope/bavaria/zugspitz3.jpg']
        },
        {
            header: 'Step Four: Embrace the Cheese'
        },
        {
            text: (
                <div>Neuschwanstein is really pretty silly. It looks impressive in pictures, but King Ludwig, who built it, never actually lived there. It was one of a few castles he built apparently for fun, rips off a different historical style in each room, has an actual man cave and a "swan room" with a truly ludicrous number of embroidered/lacquered/painted swans, and is the <a href="https://www.travelandleisure.com/trip-ideas/neuschwanstein-castle-germany?slide=547374#547374">historical basis for the Disneyland castle</a> – though it looks just as new and fake as the copy. Definitely cool to see – especially the views from the surrounding hills – but an instance where we just embraced the touristy cheesiness.</div>
            )
        },
        {
            text: (
                <div>Schloss Linderhof is even more over-the-top. Completely ostentatious, gilded, frilly – but with lots of nice walking paths on and around the grounds! We had a good laugh at how ridiculous it was while simultaneously loving the surrounding nature of the Ettaler Forest.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/westernEurope/bavaria/neuschwanstein2.jpg' 
        },
        {
            header: 'Step Five: Get the Hiking App'
        },
        {
            text: (
                <div>Komoot was a fantastic resource for finding hikes in Bavaria, and saving a detailed map offline to use with GPS. Though, Germans love their outdoorsy activities, and every trail we went to was extremely well-marked. I can't wait to visit the Alps again and do much longer hiking trips through those beautiful mountains!</div>
            )
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/westernEurope/bavaria/lake1.jpg','https://plivesey.github.io/world-of-wander-images/posts/westernEurope/bavaria/lake2.jpg']
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/westernEurope/bavaria/hike.jpg' 
        },
]
}


export default bavaria


// WEBPACK FOOTER //
// ./src/Posts/Content/Bavaria.js